export default class VolumeContainer {
  constructor(){
    this.el = document.createElement("div");
    this.el.className = "vjs-volume-container";
  }

  el(){
    return this.el;
  }
}
